export default __webpack_public_path__ + "static/media/tutorials.e0cf702b.webp";